var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentMastercardicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1758 5C25.9444 5 29 8.09091 29 11.9033C28.9998 15.7156 25.9443 18.8057 22.1758 18.8057C20.4864 18.8056 18.9416 18.1832 17.75 17.1543C16.5584 18.1832 15.0137 18.8056 13.3242 18.8057C9.55566 18.8057 6.50018 15.7156 6.5 11.9033C6.5 8.09091 9.55555 5 13.3242 5C15.0134 5.00011 16.5584 5.62186 17.75 6.65039C18.9416 5.62185 20.4866 5.00011 22.1758 5Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1758 5C25.9444 5 29 8.09091 29 11.9033C28.9998 15.7156 25.9443 18.8057 22.1758 18.8057C20.4863 18.8056 18.9416 18.1832 17.75 17.1543C19.2164 15.8882 20.1474 14.0064 20.1475 11.9033C20.1475 9.79982 19.2168 7.91652 17.75 6.65039C18.9416 5.62185 20.4866 5.00011 22.1758 5Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.749 6.65137C19.2157 7.91749 20.1465 9.79998 20.1465 11.9033C20.1465 14.0064 19.2154 15.8882 17.749 17.1543C16.2827 15.8882 15.3516 14.0064 15.3516 11.9033C15.3516 9.8 16.2824 7.91749 17.749 6.65137Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentMastercardicon);
export default __webpack_public_path__ + "static/media/payment-mastercard.icon.6ef6b9e4ef3ef9a26df2b4b37f65618d.svg";
export { ForwardRef as ReactComponent };